import ShopIcon from '@material-ui/icons/DomainRounded';
import ShopList from './ShopList';
import ShopView from './ShopView';
const ShopModule = {
    list: ShopList,
    icon: ShopIcon,
    show: ShopView,
}; export default ShopModule;